import { BaseController } from '../../common/base/controller';

export class SwitchNotAllowedController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({
      controllerService,
    });
  }

  $onInit() {
    this.foreignResidence = this.appCache.get('foreignResidence');
    this.USWithholdingTax = this.appCache.get('USWithholdingTax');
  }

  navigateToStart() {
    this.appCache.remove('foreignResidence');
    this.appCache.remove('USWithholdingTax');
    this.go('app.start');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/switchNotAllowed/switchNotAllowed.controller.js